import { BILL_AUTOMATION_UPGRADE_FIELDS, SUBSCRIPTION_FORM_SUBMIT_URL } from 'src/constants/billAutomation';

// HubSpot requires both names; '-' marks one the profile lacks rather than failing the whole request.
export const buildUpgradeSubmission = function (_ref, pageUri) {
  let firstName = _ref.firstName,
    lastName = _ref.lastName,
    email = _ref.email;
  let pageName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Bill automation upgrade (utility setup)';
  return {
    fields: [...BILL_AUTOMATION_UPGRADE_FIELDS, {
      objectTypeId: '0-1',
      name: 'firstname',
      value: firstName || '-'
    }, {
      objectTypeId: '0-1',
      name: 'lastname',
      value: lastName || '-'
    }, {
      objectTypeId: '0-1',
      name: 'email',
      value: email
    }],
    context: {
      pageUri,
      pageName
    }
  };
};

/**
 * Files an "Upgrade to Bill Automation" request on the subscription form, the same one the Subscription tab links
 * to. HubSpot's public form endpoint: no token, posted straight from the browser like the embedded form itself.
 * Resolves true only when HubSpot accepted it, so the caller never claims a request it did not send.
 */
export const requestBillAutomationUpgrade = async function (profile) {
  let pageName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  let pageUri = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window.location.href;
  if (!(profile !== null && profile !== void 0 && profile.email)) return false;
  try {
    const resp = await fetch(SUBSCRIPTION_FORM_SUBMIT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(buildUpgradeSubmission(profile, pageUri, pageName))
    });
    return resp.ok;
  } catch (ex) {
    return false;
  }
};